import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en';
import zh_hk from './zh_hk';

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: document.getElementsByTagName("html")[0].getAttribute('lang'), // set locale
    messages: {
        en,
        zh_hk
    }, // set locale messages
});

export default i18n;